import PropTypes from "prop-types";
import React from "react";

const TagsContainer = (props) => {
  const { children } = props;

  return <ul className="fr-tags-group">{children}</ul>;
};

TagsContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TagsContainer;
